
const Theme = {
	colors:{
		neutral: 'grey',
		neutralLightest: 'white',
		neutralDarker: '#30302d',
		neutralDarkest: '#1D1D1B',
		primary: '#E4003A'
	},
	responsive:{
		media : {
			xs: '400px',
			sm: '600px',
			lg: '1025px',
			xl: '1440px',
		},
		whitespace : {
			xs: 25,
			sm: 50,
			lg: 50,
			xl: 100,
		}
	}
};

export default Theme;
